import { Card } from "primereact/card"
import { JVInputCheck } from "../../shared/JVInputCheck";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { ICityMastDropdown, IClientCompanyDropdown, IStateMastDropdown, IVisaDropdown } from "../../models/IDropdown";
import { useEffect, useState } from "react";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { NoticePeriod } from "../../models/FDropdown";
import { JVMultiselect } from "../../shared/JVMultiselect";
import { JVDate } from "../../shared/JVDate";
import { JVInputMask } from "../../shared/JVInputMask";
import { Dialog } from "primereact/dialog";

interface IProps {
    loadTableData: (query?: string) => void,
    sFilter: IEmptyForm,
    setSFilter: (sFilter: IEmptyForm) => void,
    showFilter: boolean,
    loading: boolean,
    lazyParams: ILazyParams,
    filterApply: boolean,
}

interface ISourceDropdown {
    sourceId: number,
    source_Name: string
}

export interface IEmptyForm {
    query?: string | null,
    jobTitles?: string | null,
    rateFrom?: number | null,
    rateTo?: number | null,
    salaryFrom?: number | null,
    salaryTo?: number | null,
    availability?: string | null,
    relocation?: string | null,
    source?: number | null,
    visa?: number[] | null,
    location?: {
        state_ID?: number | null,
        state_Name?: string | null,
    },
    prefferLocation?: {
        state_ID?: number | null,
        state_Name?: string | null,
    },
    expFrom?: number | null,
    expTo?: number | null,
    added?: string | null,
    // edited?: string | null,
    submited?: string | null,
    // blocked?: string | null,
    // deleted?: string | null,
    added_From?: Date | null,
    added_To?: Date | null,
    submited_From?: Date | null,
    submited_To?: Date | null,
    email?: string | null,
    consID?: string | null,
    phoneNo?: string | null,
    cellNo?: string | null,
    companyName?: any | null,
    contactPersonEmail?: string | null,
    city?: ICityMastDropdown | null,
    state?: IStateMastDropdown | null,
    searchForVisa?: number | null,
    searchForState?: string | null,
    searchForSub?: boolean | null,
    searchForECI?: boolean | null,
    all?: boolean | null,
}

export const EmptyForm: IEmptyForm = {
    query: "",
    jobTitles: "",
    rateFrom: 0,
    rateTo: 0,
    salaryFrom: 0,
    salaryTo: 0,
    availability: "",
    relocation: "",
    source: 0,
    visa: [],
    location: {
        state_ID: 0,
        state_Name: "",
    },
    prefferLocation: {
        state_ID: 0,
        state_Name: "",
    },
    expFrom: 0,
    expTo: 0,
    added: "",
    // edited: "",
    submited: "",
    // blocked: "",
    // deleted: "",
    added_From: null,
    added_To: null,
    submited_From: null,
    submited_To: null,
    email: "",
    consID: "",
    phoneNo: "",
    cellNo: "",
    companyName: null,
    contactPersonEmail: "",
    all: true
}

const schema = yup.object({
    query: yup.string().nullable(),
    jobTitles: yup.string().nullable(),
    rateFrom: yup.string().nullable(),
    rateTo: yup.string().nullable(),
    salaryFrom: yup.string().nullable(),
    salaryTo: yup.string().nullable(),
    availability: yup.string().nullable(),
    relocation: yup.string().nullable(),
    source: yup.number().nullable(),
    visa: yup.array().of(yup.number()),
    location: yup.object().shape({
        state_ID: yup.number(),
        state_Name: yup.string(),
    }).nullable(),
    prefferLocation: yup.object().shape({
        state_ID: yup.number(),
        state_Name: yup.string(),
    }).nullable(),
    expFrom: yup.string().nullable(),
    expTo: yup.string().nullable(),
    added: yup.string().nullable(),
    // edited: yup.string(),
    submited: yup.string().nullable(),
    // blocked: yup.string(),
    // deleted: yup.string(),
    added_From: yup.date().nullable(),
    added_To: yup.date().nullable(),
    submited_From: yup.date().nullable(),
    submited_To: yup.date().nullable(),
    email: yup.string().nullable(),
    consID: yup.string().nullable(),
    phoneNo: yup.string().nullable(),
    cellNo: yup.string().nullable(),
    // companyName: yup.string(),
    contactPersonEmail: yup.string().nullable(),
    state: yup.object().shape({
        state_ID: yup.number().min(1, "State is required*").nullable(),
        state_Name: yup.string().nullable()
    }).nullable(),
    city: yup.object().when('state', val => {
        return (val !== undefined && val !== null) ?
            yup.object().nullable() :
            yup.object().shape({
                city_ID: yup.number().min(1, "City is required*").required("City is required*"),
                city_Name: yup.string().required()
            })
    }),
});

export const Filter = (props: IProps) => {
    const [visa, setVisa] = useState<Array<IVisaDropdown>>();
    const [selectedVisa, setSelectedVisa] = useState<Array<IVisaDropdown>>();
    const [source, setSource] = useState<Array<ISourceDropdown>>();
    const [location, setLocation] = useState<Array<IStateMastDropdown>>();
    const [prefLocation, setPrefLocation] = useState<Array<IStateMastDropdown>>();
    const [vendorCompanies, setVendorCompanies] = useState<Array<IClientCompanyDropdown>>([]);
    const [states, setStates] = useState<Array<IStateMastDropdown>>();
    const [cities, setCities] = useState<Array<ICityMastDropdown>>();
    const [openHelp, setOpenHelp] = useState(false);
    const { control, handleSubmit, formState: { errors }, watch, reset, setValue } = useForm<IEmptyForm>({
        resolver: yupResolver(schema),
        shouldFocusError: false,
        defaultValues: EmptyForm
    });

    const searchReq = () => {
        console.log(control._formValues.query);
        // props.loadTableData(control._formValues.query);
        return {};
    };

    const Experience = [
        { num: 0 },
        { num: 1 },
        { num: 2 },
        { num: 3 },
        { num: 4 },
        { num: 5 },
        { num: 6 },
        { num: 7 },
        { num: 8 },
        { num: 9 },
        { num: 10 },
        { num: 11 },
        { num: 12 },
        { num: 13 },
        { num: 14 },
        { num: 15 },
        { num: 16 },
        { num: 17 },
        { num: 18 },
        { num: 19 },
        { num: 20 },
        { num: 21 },
        { num: 22 },
        { num: 23 },
        { num: 24 },
        { num: 25 },
        { num: 26 },
        { num: 27 },
        { num: 28 },
        { num: 29 },
        { num: 30 },
    ];

    const loadAvailability = async () => {
        const response = await Fetch("", "GET", null, null, null);
        if (response) { }
    };
    const loadSource = async () => {
        const response = await Fetch("Dropdown/source", "GET", null, null, null);
        if (response) {
            const data: Array<ISourceDropdown> = await response.json();
            let newData: Array<ISourceDropdown> = [{
                sourceId: 0,
                source_Name: "--Select--",
            }, ...data];

            setSource(newData);
        }
    };
    const loadVisa = async () => {
        const response = await Fetch("Dropdown/visa", "GET", null, null, null);
        if (response) {
            const data: Array<IVisaDropdown> = await response.json();
            let newData: Array<IVisaDropdown> = [{
                visaId: 0,
                visa_Name: "--Select--"
            }, ...data];
            setVisa(newData);
        }
    }
    const loadLocation = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IStateMastDropdown> = await response.json();
            let newData: Array<IStateMastDropdown> = [{
                state_ID: 0,
                state_Name: "--Select--",
            }, ...data];
            setLocation(newData);
        }
    };
    const completeMethodLocation = (event: { query: string }) => {
        loadLocation(event.query);
    }
    const loadPrefferLocation = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IStateMastDropdown> = await response.json();
            let newData: Array<IStateMastDropdown> = [{
                state_ID: 0,
                state_Name: "--Select--",
            }, ...data];
            setPrefLocation(newData);
        }
    };
    const completeMethodPrefferLocation = (event: { query: string }) => {
        loadPrefferLocation(event.query);
    }

    const PrefferLocation = async () => {
        const response = await Fetch("", "GET", null, null, null);
        if (response) { }
    };
    const Exp = async () => {
        const response = await Fetch("", "GET", null, null, null);
        if (response) { }
    };

    const OnSubmit = (formData: IEmptyForm) => {

        let data: any = formData;
        data.companyName = data?.companyName?.vendor_Company_ID;
        const selectedVisas = (selectedVisa || [])?.map((v: IVisaDropdown) => v.visaId).filter((i: number) => i > 0);
        data.visa = selectedVisas.length > 0 ? selectedVisas : null;
        data.state = data.state?.state_Name;
        data.city = data.city?.city_ID;
        if (formData.query?.includes(",")) {
            data.query = data.query.split(",").map((el: any) => el.trim()).filter((el: any) => el.trim() !== "").join(", ");
        }
        if (formData.added) {
            data.added = Number(formData.added) || 0;
        }
        if (formData.submited) {
            data.query = Number(formData.submited) || 0;
        }
        if (formData.rateFrom) {
            data.rateFrom = Number(formData.rateFrom) || 0;
        }
        if (formData.rateTo) {
            data.rateTo = Number(formData.rateTo) || 0;
        }
        if (formData.salaryFrom) {
            data.salaryFrom = Number(formData.salaryFrom) || 0;
        }
        if (formData.salaryTo) {
            data.salaryTo = Number(formData.salaryTo) || 0;
        }
        if (formData.expFrom) {
            data.expFrom = Number(formData.expFrom) || 0;
        }
        if (formData.expTo) {
            data.expTo = Number(formData.expTo) || 0;
        }
        // console.log(data);
        props.setSFilter(data);
        props.loadTableData(encodeURIComponent(JSON.stringify(data)));
    };

    const loadVendorCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/sub_vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setVendorCompanies(data);
        }
    }

    const searchSub = (event: { query: string }) => {
        if ((event.query).trim().length >= 1) {
            loadVendorCompanies(event.query);
        }
    }

    const loadCities = async (filter: string | null) => {
        if (control._formValues.state?.state_ID) {
            const response = await Fetch("Dropdown/cities", "GET", null, `filter=${filter}&state_id=${control._formValues.state.state_ID}`, null);
            if (response) {
                const data: Array<ICityMastDropdown> = await response.json();
                setCities(data);
            }
        } else {

        }
    }
    const completeMethodCities = (event: { query: string }) => {
        loadCities(event.query);
    }

    const loadStates = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IStateMastDropdown> = await response.json();
            setStates(data);
        }
    }
    const completeMethodStates = (event: { query: string }) => {
        loadStates(event.query);
    }

    useEffect(() => {
        loadVisa();
        loadSource();
    }, []);

    useEffect(() => {
        if (props.filterApply) {
            const formData = props.sFilter;
            let data: any = formData;
            data.companyName = data?.companyName?.vendor_Company_ID;
            const selectedVisas = (selectedVisa || [])?.map((v: IVisaDropdown) => v.visaId).filter((i: number) => i > 0);
            data.visa = selectedVisas.length > 0 ? selectedVisas : null;
            data.state = data.state?.state_Name;
            data.city = data.city?.city_ID;
            if (formData.query?.includes(",")) {
                data.query = data.query.split(",").map((el: any) => el.trim()).filter((el: any) => el.trim() !== "").join(", ");
            }
            if (formData.added) {
                data.added = Number(formData.added) || 0;
            }
            if (formData.submited) {
                data.query = Number(formData.submited) || 0;
            }
            if (formData.rateFrom) {
                data.rateFrom = Number(formData.rateFrom) || 0;
            }
            if (formData.rateTo) {
                data.rateTo = Number(formData.rateTo) || 0;
            }
            if (formData.salaryFrom) {
                data.salaryFrom = Number(formData.salaryFrom) || 0;
            }
            if (formData.salaryTo) {
                data.salaryTo = Number(formData.salaryTo) || 0;
            }
            if (formData.expFrom) {
                data.expFrom = Number(formData.expFrom) || 0;
            }
            if (formData.expTo) {
                data.expTo = Number(formData.expTo) || 0;
            }

            props.loadTableData(encodeURIComponent(JSON.stringify(data)));
        }
    }, [props.lazyParams]);

    return (
        <>
            <form onSubmit={handleSubmit(OnSubmit)} style={{ display: props.showFilter ? "block" : "none" }}>
                <Card className="border-top-3 border-primary">
                    <div className="p-fluid formgrid grid">
                        {/* <JVInputCheck column={1} placeholder="Search String" control={control} name="query" func={searchReq} error={errors.query?.message} /> */}
                        {/* <JVInputCheck column={1} func={searchReq} control={control} name="query" /> */}
                        <div className="field col-12 md:col-12 flex">
                            <div className="" style={{ width: "98%", marginLeft: "-10px" }}><JVInput column={1} label="Search String" control={control} name="query" error={errors.query?.message} placeholder="Search String" /></div>
                            <span style={{ borderRadius: "50%", fontSize: '1.5rem', backgroundColor: "#2196F3", padding: "5px", color: "white", height: "31px", marginTop: "1.75rem" }} className="pi pi-question-circle" onClick={() => setOpenHelp(true)} />
                        </div>

                        {/* <JVInput column={6} label="Cons. Email" control={control} name="email" error={errors.email?.message} />
                        <JVInput column={6} label="Cons.ID" control={control} name="consID" error={errors.consID?.message} />
                        <JVInput column={6} label="Cons. Phone No" control={control} name="phoneNo" error={errors.phoneNo?.message} />
                        <JVInput column={6} label="Cons. Cell No." control={control} name="cellNo" error={errors.cellNo?.message} /> */}
                        {/* <JVInput column={6} label="Company Name" control={control} name="companyName" error={errors.companyName?.message} /> */}
                        {/* <JVDropdownInput column={6} completeMethod={searchSub} label="Company Name" control={control} name="companyName" options={vendorCompanies} optionLabel="vendor_Company_Name" placeholder="Search Vendor/Company" />
                        <JVInput column={6} label="Contact Person Email" control={control} name="contactPersonEmail" error={errors.contactPersonEmail?.message} placeholder="Enter Vendor Email" /> */}

                        <JVInput column={4} label="Job Titles" control={control} name="jobTitles" error={errors.jobTitles?.message} />
                        <div className="field col-12 md:col-3 flex p-0">
                            <div className="w-6">
                                <JVInput column={1} control={control} label="Rate From :" name="rateFrom" error={errors.rateFrom?.message} />
                            </div>
                            <div className="w-6">
                                <JVInput column={1} control={control} label="Rate To :" name="rateTo" error={errors.rateTo?.message} />
                            </div>
                        </div>
                        {/* <JVInput column={4} label="Salary" control={control} name="salary" error={errors.salary?.message} /> */}
                        <div className="field col-12 md:col-3 flex p-0">
                            <div className="w-6">
                                <JVInput column={1} control={control} label="Salary From :" name="salaryFrom" error={errors.salaryFrom?.message} />
                            </div>
                            <div className="w-6">
                                <JVInput column={1} control={control} label="Salary To :" name="salaryTo" error={errors.salaryTo?.message} />
                            </div>
                        </div>
                        <JVDropdown column={4} label="Availability" control={control} name="availability" options={NoticePeriod} optionLabel="name" optionValue="value" placeholder="Select Availability" error={errors.availability?.message} />

                        {/* <JVDropdown column={6} label="Relocation" control={control} name="relocation" options={[{ relocation: "--Select--" }, { relocation: "Yes" }, { relocation: "No" }]} optionLabel="relocation" optionValue="relocation" placeholder="Select" error={errors.relocation?.message} /> */}
                        {/* <JVDropdown column={6} label="Source" control={control} name="source" options={source} optionLabel="source_Name" optionValue="sourceId" placeholder="Select Source" error={errors.source?.message} /> */}
                        <JVMultiselect column={6} label="Visa" options={visa} optionLabel="visa_Name" placeholder="Select visa" value={selectedVisa} onChange={setSelectedVisa} />
                        {/* <JVDropdownInput column={6} completeMethod={completeMethodLocation} label="Location" control={control} name="location" options={location} optionLabel="state_Name" placeholder="Search Location" error={errors.location?.state_Name?.message} /> */}
                        <JVDropdownInput column={6} completeMethod={completeMethodStates} label="Location State" control={control} name="state" error={errors.state?.state_ID?.message} options={states} optionLabel="state_Name" placeholder="Search State" />
                        <JVDropdownInput column={6} completeMethod={completeMethodCities} label="Location City" control={control} name="city" error={errors.city?.city_ID?.message} options={cities} optionLabel="city_Name" placeholder="Search City" />
                        {/* <JVDropdownInput column={6} completeMethod={completeMethodPrefferLocation} label="Preffer Location" control={control} name="prefferLocation" options={prefLocation} optionLabel="state_Name" placeholder="Search Preffer Location" error={errors.prefferLocation?.state_Name?.message} /> */}
                        <div className="field col-12 md:col-2 flex p-0">
                            <div className="w-6">
                                <JVInput column={1} control={control} label="Exp From :" name="expFrom" error={errors.expFrom?.message} />
                            </div>
                            <div className="w-6">
                                <JVInput column={1} control={control} label="Exp To :" name="expTo" error={errors.expTo?.message} />
                            </div>
                        </div>
                        {/* <JVDropdown column={6} label="Exp" control={control} name="exp" options={Experience} optionLabel="num" optionValue="num" placeholder="Select Experience" error={errors.exp?.message} /> */}
                        {/* <JVDropdown column={6} label="Preffer Location" control={control} name="company" options={location} optionLabel="state_Name" optionValue="state_ID" placeholder="Select Preffer Location" /> */}
                        {/* <JVDropdown column={6} label="Location" control={control} name="company" options={location} optionLabel="state_Name" optionValue="state_ID" placeholder="Select Location" /> */}
                        {/* <div className="field col-12 md:col-3 flex p-0">
                            <div className="w-6">
                                <JVDate maxDate={new Date} column={1} label="Added From" control={control} name="added_From" />
                            </div>
                            <div className="w-6">
                                <JVDate maxDate={new Date} column={1} label="Added To" control={control} name="added_To" />
                            </div>
                        </div>
                        <div className="field col-12 md:col-3 flex p-0">
                            <div className="w-6">
                                <JVDate maxDate={new Date} column={1} label="Submited From" control={control} name="submited_From" />
                            </div>
                            <div className="w-6">
                                <JVDate maxDate={new Date} column={1} label="Submited To" control={control} name="submited_To" />
                            </div>
                        </div> */}
                        <div className="col-12 md:col-12 flex gap-4">
                            <Button className="field col md:col" label="Search" type="submit" loading={props.loading} disabled={props.loading} ></Button>
                            <Button className="field col md:col p-button-outlined" label="Clear" onClick={() => {
                                reset(EmptyForm);
                                setSelectedVisa([]);
                            }} type="button"></Button>
                        </div>
                    </div>
                </Card>
                <h3>Day back Search</h3>
                <Card className="border-top-3 border-primary">
                    <div className="p-fluid formgrid grid">
                        <div className="field col-12 md:col-2 flex p-0">
                            <JVInput control={control} column={1} label="Added :" name="added" error={errors.added?.message} />
                        </div>
                        <div className="field col-12 md:col-3 flex p-0">
                            <div className="w-6">
                                <JVDate maxDate={new Date} column={1} label="Added From" control={control} name="added_From" />
                            </div>
                            <div className="w-6">
                                <JVDate maxDate={new Date} column={1} label="Added To" control={control} name="added_To" />
                            </div>
                        </div>
                        <div className="field col-12 md:col-2 flex p-0">
                            <JVInput control={control} column={1} label="Submited :" name="submited" error={errors.submited?.message} />
                        </div>
                        <div className="field col-12 md:col-3 flex p-0">
                            <div className="w-6">
                                <JVDate maxDate={new Date} column={1} label="Submited From" control={control} name="submited_From" />
                            </div>
                            <div className="w-6">
                                <JVDate maxDate={new Date} column={1} label="Submited To" control={control} name="submited_To" />
                            </div>
                        </div>

                    </div>
                </Card>
                {/* <JVInput column={6} label="Blocked" control={control} name="blocked" error={errors.blocked?.message} /> */}
                {/* <JVInput column={6} label="Deleted" control={control} name="deleted" error={errors.deleted?.message} /> */}


                <h3>Other Information</h3>
                <Card className="border-top-3 border-primary">
                    <div className="p-fluid formgrid grid">
                        <JVInput column={6} label="Cons. Email" control={control} name="email" error={errors.email?.message} />
                        <JVInput column={6} label="Cons.ID" control={control} name="consID" error={errors.consID?.message} />
                        <JVInputMask column={6} mask="(999) 999-9999" label="Cons. Phone No" control={control} name="phoneNo" error={errors.phoneNo?.message} />
                        <JVInputMask column={6} mask="(999) 999-9999" label="Cons. Cell No." control={control} name="cellNo" error={errors.cellNo?.message} />
                        <JVDropdownInput column={6} completeMethod={searchSub} label="Company Name" control={control} name="companyName" options={vendorCompanies} optionLabel="vendor_Company_Name" placeholder="Search Vendor/Company" />
                        <JVInput column={6} label="Contact Person Email" control={control} name="contactPersonEmail" error={errors.contactPersonEmail?.message} placeholder="Enter Vendor Email" />
                    </div>
                </Card>
            </form >
            <Dialog visible={openHelp} style={{ width: '80vw' }} header="How To Search" modal className="p-fluid" onHide={() => setOpenHelp(false)}>
                <div style={{ fontFamily: "Arial, sans-serif", lineHeight: "1.6" }}>
                    <h2 style={{ color: "green" }}>✅ How to Use the Search Bar (Frontend)</h2>
                    <p>You can search using:</p>
                    <ul>
                        <li>📘 <strong>Single keywords</strong> (e.g., <code>Java</code>)</li>
                        <li>🔗 <strong>Multiple comma-separated terms</strong> (e.g., <code>Java, Spring, Developer</code>)</li>
                        <li>✖️ <strong>Quoted phrases</strong> for exact matches (e.g., <code>"full stack developer"</code>)</li>
                        <li>⚙️ <strong>Logical operators</strong> like <code>AND</code>, <code>OR</code>, <code>NOT</code> for advanced search control</li>
                    </ul>

                    <hr />

                    <h3>💡 Input Format Rules</h3>
                    <ul>
                        <li>
                            <strong>Separate multiple keywords using <em>commas</em>:</strong><br />
                            ➤ <code>Java, React, .NET</code><br />
                            &rarr; This is interpreted as <code>Java AND React AND .NET</code> (all must be present)
                        </li>
                        <br />
                        <li>
                            <strong>Use <em>double quotes</em> "<code>"</code> for exact phrases:</strong><br />
                            ➤ <code>"project manager", "data analyst"</code><br />
                            &rarr; This searches for the exact phrases
                        </li>
                        <br />
                        <li>
                            <strong>Use <em>logical operators</em> for more control:</strong>
                            <ul>
                                <li>🧠 <code>AND</code>: All terms must be present</li>
                                <li>🔀 <code>OR</code>: At least one term must be present</li>
                                <li>🚫 <code>NOT</code>: Excludes terms</li>
                            </ul>
                        </li>
                        <br />
                        <li><strong>Extra spaces</strong> or empty entries are automatically removed</li>
                    </ul>
                </div>
            </Dialog>
        </>
    );
}